export const PluginID = 'acc-docs-editor';
